import styles from "./TextInput.module.css";
import { classnames } from "../../utils/index.jsx";

export default function TextInputStandalone({
  label,
  className,
  mandatory,
  unit,
  size,
  subText,
  placeholder,
  error,
  hidden,
  transformValue,
  onChange,
  ...props
}) {
  const classes = classnames(styles.control, className, error && styles.error);

  const min =
    props.type === "number" && props.min === undefined ? 0 : props.min;

  function changeHandler(e) {
    if (transformValue) {
      e.target.value = transformValue(e.target.value);
    }
    if (onChange) onChange(e);
  }

  return (
    <div className={classes} hidden={hidden}>
      {label && (
        <div className={"flex"}>
          <label htmlFor={props.id || props.name}>
            {label}
            {mandatory && <span className={"blueStar"}> *</span>}
          </label>
        </div>
      )}
      {unit ? (
        <div className={styles.inputGroup}>
          <input
            {...props}
            placeholder={placeholder}
            className={classnames(
              styles.inputField,
              styles.textInput,
              styles[size],
              "flex-grow",
            )}
            min={min}
            onWheel={(e) => props.type === "number" && e.target.blur()}
            onChange={changeHandler}
          />
          <div className={classnames(styles.inputUnit)}>{unit}</div>
        </div>
      ) : (
        <input
          {...props}
          placeholder={placeholder}
          className={classnames(styles.textInput, styles[size])}
          min={min}
          onWheel={(e) => props.type === "number" && e.target.blur()}
          onChange={changeHandler}
        />
      )}
      {subText ? <p className={"secondaryText"}>{subText}</p> : ""}
      {error && <div>{error}</div>}
    </div>
  );
}
